import React, { useState, useEffect } from "react";
import { VertContainer } from "@vertem-core/vertice-ds";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography } from "antd";
import BalloonCard from "./BallonCard";
import BalloonModal from "./BallonModal";
import "./showcasePopBallon.less";
import { openModal, closeModal } from "redux/Reducers/PopBallon/VertemGiftSlice";
import { getAvailableBallons } from "redux/Reducers/PopBallon/VertemGiftApi";

const { Text } = Typography;

const ShowcasePopBalloon = () => {
  const dispatch = useDispatch();
  const { availableBallons } = useSelector(state => state.VertemGift);
  const { isModalOpen } = useSelector(state => state.VertemGift)
  const [selectedBalloon, setSelectedBalloon] = useState(null);

  useEffect(() => {
    dispatch(getAvailableBallons())
  }, []);

  const handleBalloonSelect = (balloon) => {
    dispatch(openModal())
  };

  const handleModalClose = () => {
    dispatch(getAvailableBallons());
    dispatch(closeModal());
  };

  return (
    <VertContainer className="margin-bottom-regular padding-x-regular">
      {availableBallons.length > 0 ? (
        <BalloonCard
          balloon={availableBallons[0]}
          onSelect={handleBalloonSelect}
        />
      ) : (
        <div className="txt-number-ballon">
          <Text>
            Não há balão disponível para resgate.
          </Text>
        </div>
      )}

      {availableBallons.length > 0 && (
        <div className="txt-number-ballon">
          <Text>
            Você possui{" "}
            <strong className="color-ui">{availableBallons.length} {availableBallons.length === 1 ? 'Balão' : 'Balões'}</strong>{" "}
            {availableBallons.length === 1 ? 'disponível' : 'disponíveis'}.
          </Text>
        </div>
      )}


      {isModalOpen && (
        <BalloonModal
          balloon={selectedBalloon}
          onClose={handleModalClose}
        />
      )}
    </VertContainer>
  );
};

export default ShowcasePopBalloon;
